import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConfigurareProgram, Program, ProgramUpdate, SlotBlocare, SlotBlocareUpdate } from './program.interface';

@Injectable({
    providedIn: 'root'
})
export class ProgramService {
    private basePath = environment.interop.basePath;

    private storeUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.program.store;
    private updateUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.program.update;
    private deleteUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.program.delete;
    private updateConfigurationUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.program.updateConfiguration;
    private updateSlotsUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.program.updateSlots;

    // Sloturi blocare
    private storeSloturiUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.sloturiBlocare.store;
    private updateSloturiUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.sloturiBlocare.update;
    private deleteSloturiUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.sloturiBlocare.delete;

    constructor(private http: HttpClient) { }

    add(program: Program) {
        return this.http.post(this.storeUrl, program);
    }

    update(program: ProgramUpdate) {
        return this.http.put(this.updateUrl, program);
    }

    delete(id: number) {
        return this.http.delete(this.deleteUrl + id);
    }

    updateConfiguration(id: number, configuration: ConfigurareProgram) {
        return this.http.patch(this.updateConfigurationUrl + id, configuration);
    }

    updateSlots(id: number, slots: any) {
        return this.http.patch(this.updateSlotsUrl + id, slots);
    }

    // Sloturi blocare
    addSlotBlocare(slotBlocare: SlotBlocare) {
        return this.http.post(this.storeSloturiUrl, slotBlocare);
    }

    updateSlotBlocare(slotBlocare: SlotBlocareUpdate) {
        return this.http.put(this.updateSloturiUrl, slotBlocare);
    }

    deleteSlotBlocare(id: number) {
        return this.http.delete(this.deleteSloturiUrl + id);
    }
}
